<div class="flex justify-center items-center">
  <div class="flex flex-col basis-1/3 items-center">
    @if (primaryLabel) {
      <div class="b1 text-gray-1000 mb-1">
        {{ primaryLabel }}
      </div>
    }
    @if (primaryValue !== null) {
      <m-tooltip
        [content]="primaryDescription"
        [tooltipOptions]="tooltipOptions">
        <div class="b2 text-blue-600">
          {{ primaryValue | number }}
        </div>
      </m-tooltip>
    } @else {
      <div class="b1 text-gray-800">N/A</div>
    }
  </div>

  <div
    class="m-bar-wrapper flex flex-col gap-1.5"
    [ngClass]="{ 'no-animation': !animate }">
    <p-progressBar
      [ngClass]="
        primaryValue !== null && secondaryValue !== null
          ? primaryValue > secondaryValue
            ? 'success'
            : 'danger'
          : 'secondary'
      "
      [value]="primaryHeight"
      [showValue]="false"></p-progressBar>

    <p-progressBar
      class="secondary"
      [value]="secondaryHeight"
      [showValue]="false">
    </p-progressBar>
  </div>

  <div class="flex flex-col basis-1/3 items-center">
    @if (secondaryLabel) {
      <div class="b1 text-gray-1000 mb-1">
        {{ secondaryLabel }}
      </div>
    }
    @if (secondaryValue !== null) {
      <m-tooltip
        [content]="secondaryDescription"
        [tooltipOptions]="tooltipOptions">
        <div class="b2 text-blue-600">
          {{ secondaryValue | number }}
        </div>
      </m-tooltip>
    } @else {
      <div class="b1 text-gray-800">N/A</div>
    }
  </div>
</div>
